import React, { useState, useEffect, useRef } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import Eid from './Eid';
import { categoryList } from '../services/General-service';
var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    swipe: true,
    swipeToSlide: true,
    touchMove: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0
        }
      }
    ]
  };


function Browse({ onViewAllClick, onCategoryClick, showTrending = true }) {
    
    const [hideTitle, sethideTitle] = useState(true);
    const [categoryArr,setCategoryArr] = useState([]);
    const sliderRef = useRef(null);
    const handleCategoryClick = () => {
        if (onCategoryClick) {
            onCategoryClick();
        }
    };
    const getCategoryLink = (category) => {
        const categoryId = category?.category_id || category?.id;
        return categoryId ? `/category/?category_ids=${categoryId}` : '/category';
    };

    const getCategoryList = () =>{
        categoryList('').then((data) =>{
           
            setCategoryArr(data.data);
            }
            
        ).catch((error)=>{

        })
    }

    useEffect(()=> {
        getCategoryList();
    },[])

    // Modal / delayed mount often leaves slick track offset; re-measure so swipe works like desktop
    useEffect(() => {
        if (!categoryArr || categoryArr.length === 0) return undefined;

        const refreshSlider = () => {
            const slider = sliderRef.current;
            if (!slider) return;
            try {
                if (typeof slider.slickGoTo === 'function') {
                    slider.slickGoTo(0, true);
                }
            } catch (e) {
                // ignore
            }
            window.dispatchEvent(new Event('resize'));
        };

        const t1 = window.setTimeout(refreshSlider, 60);
        const t2 = window.setTimeout(refreshSlider, 220);
        return () => {
            window.clearTimeout(t1);
            window.clearTimeout(t2);
        };
    }, [categoryArr])
    return (
        <div>
                <div className='BrowseCategories'>
                    <div className='App HomeSection'>
                        <div className="BreakPointContainer">
                            <div className="CarouselSectionContainer CarouselOneSectionContainer">
                                <div className="layout row justify-space-between align-center text-left SectionTitle">
                                    <h1 className='m-t-0 m-b-0 demi-bold w-auto'> BROWSE CATEGORIES </h1>
                                </div>
                                <div className="slider-container">
                                    <Slider ref={sliderRef} {...settings}>
                                        {categoryArr && categoryArr.length > 0 && categoryArr.map((data, index) => (
                                            <div className='item' key={index}>
                                                <div className="CarouselSection product">
                                                    <div className="prel Gutter">
                                                        <Link
                                                            to={getCategoryLink(data)}
                                                            onClick={() => handleCategoryClick()}
                                                        >
                                                            <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '130%', overflow: 'hidden' }}>
                                                                <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '20%' }}>
                                                                    {data.thumbnail ? (
                                                                        <img
                                                                            src={data.thumbnail}
                                                                            alt={data.title}
                                                                            className='img-resp DynamicHeightLoaderImage'
                                                                            style={{ padding: '0px' }}
                                                                            onError={(e) => {
                                                                                e.currentTarget.style.visibility = 'hidden';
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                </div>
                                                                <div className="animated-bg-placeholder"></div>
                                                            </div>
                                                            <div className="ImageTextDetail ProductImageTextDetail">
                                                                <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.title} </label>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showTrending && (
                  <div className='App demo'>
                      <div className="BreakPointContainer">
                          <div className="layout row justify-space-between align-center text-left SectionTitle">
                              <h1 className='m-t-0 m-b-0 demi-bold w-auto'> TRENDING PRODUCTS </h1>
                              <Link 
                                to="/category" 
                                className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'
                                onClick={() => {
                                  if (onViewAllClick) {
                                    onViewAllClick();
                                  }
                                }}
                              >
                                VIEW ALL
                              </Link>
                          </div>
                          <Eid showeidpicks={true} notShowTitle={hideTitle} />
                      </div>
                  </div>
                )}
       </div>
    )
}

export default Browse